<template>
  <div class="bed-board-page">
    <div class="org-content" v-if="state.isLogin">
      <van-dropdown-menu v-if="state.permissionType == 1">
        <van-dropdown-item @change="handleOrgChange" v-model="state.currentOrg" :options="state.orgList" />
      </van-dropdown-menu>
      <van-icon style="position: absolute;right: 12px;" size="20" @click="onRefresh" name="replay" />
    </div>

    <!-- 状态色块说明 -->
    <div class="legend" v-if="state.isLogin">
      <div class="legend-item">
        <span class="legend-dot legend-occupied"></span>
        <span class="legend-text">已入住</span>
      </div>
      <div class="legend-item">
        <span class="legend-dot legend-pending"></span>
        <span class="legend-text">待入住</span>
      </div>
      <div class="legend-item">
        <span class="legend-dot legend-free"></span>
        <span class="legend-text">空床</span>
      </div>
      <div class="legend-item">
        <span class="bunk-dot up"></span>
        <span class="legend-text">上铺</span>
      </div>
      <div class="legend-item">
        <span class="bunk-dot down"></span>
        <span class="legend-text">下铺</span>
      </div>
      <div class="legend-item">
        <span class="bunk-dot dai"></span>
        <span class="legend-text">待</span>
      </div>
    </div>

    <div class="summary" v-if="state.isLogin">
      <div class="summary-item">总床位: {{ state.summary.total ?? '--' }}</div>
      <div class="summary-item">已入住: {{ state.summary.occupied ?? '--' }}</div>
      <div class="summary-item">待入住: {{ state.summary.pending ?? '--' }}</div>
      <div class="summary-item">空闲: {{ state.summary.free ?? '--' }}</div>
    </div>

    <!-- 顶部快速筛选 -->
    <div class="quick-filters" v-if="state.isLogin">
      <div class="filter-group">
        <span class="filter-label">性别</span>
        <van-tabs v-model:active="state.genderFilter" shrink @change="onGenderChange">
          <van-tab name="all" title="全部" />
          <van-tab name="1" title="男" />
          <van-tab name="2" title="女" />
        </van-tabs>
      </div>
      <div class="filter-group">
        <span class="filter-label">类型</span>
        <van-tabs v-model:active="state.useageFilter" shrink @change="onUseageChange">
          <van-tab name="all" title="全部" />
          <van-tab name="1" title="全托" />
          <van-tab name="2" title="午托" />
        </van-tabs>
      </div>
    </div>

    <div class="board-container" v-if="state.isLogin">
      <!-- <div class="left-list">
        <div class="room-list">
          <div
            v-for="(room, idx) in state.rooms"
            :key="room.roomId || room.roomNo || idx"
            class="room-item"
            @click="() => scrollToRoom(room, idx)"
          >
            <div class="room-title">
              <span>{{ room.roomNo }}</span>
            </div>
            <div class="room-stats">
              <div class="stat"><van-icon name="smile-o" /> {{ room.occupied ?? 0 }}</div>
              <div class="stat"><van-icon name="passed" /> {{ room.free ?? 0 }}</div>
            </div>
          </div>
          <EmptyData v-if="!state.rooms.length" />
        </div>
      </div> -->

      <div class="right-content" ref="rightContentRef">
        <div
          v-for="(room, idx) in displayedRooms"
          :key="room.roomId || room.roomNo || idx"
          class="room-panel"
          :id="roomDomId(room, idx)"
        >
          <div class="panel-header">
            <div class="room-name">{{ room.roomNo || '房间' }}</div>
            <div class="panel-meta">已住: {{ room.occupied ?? 0 }} / 待住: {{ room.pending ?? 0 }} / 空床: {{ room.free ?? 0 }}</div>
          </div>
          <div class="bed-grid">
            <div
              v-for="(bed, bIdx) in filteredBeds(room)"
              :key="bed.bedId || bed.bedNo || bIdx"
              class="bed-card"
              :class="bedStatusClass(bed)"
              @click="goBedRecords(room, bed)"
            >
              <div class="bed-header">
                <div class="bed-no">{{ bed.bedNo || '床位' }}</div>

                <div style="display: flex; align-items: center;">
                  <span v-if="bed.bedPositionName || bed.bedPosition !== undefined" class="bunk-badge" :title="bed.bedPositionName || ''">
                  <span class="bunk-dot" :class="bunkDotClass(bed)"></span>
                </span>

                
                </div>
                

              </div>
              <div class="bed-meta" v-if="bed.checkInDate">
                {{bed.checkInDate }}
              </div>
              <div class="bed-meta" v-if="bed.expireDate">
                {{bed.expireDate }}
              </div>
              <div class="bed-sub">
                <div class="stu-name" v-if="bed.userName">
                  {{ bed.userName }}
                  <div v-if="bed.statusFlag" class="bunk-badge" style="margin-left: 4px; margin-top: -2px" :title="bed.bedPositionName || ''">
                    <span class="bunk-dot dai"></span>
                </div>
                </div>
                <div class="stu-empty" v-else>空床位</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="login-tips" v-else>
      <van-empty description="请先登录后查看床位看板" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import EmptyData from '@/components/EmptyData.vue';
import { postRoomBedUsageStats, querySelectOrgListByUser } from '@/api/user';
import { showLoadingToast, closeToast, showNotify } from 'vant';

export default defineComponent({
  name: 'BedBoard',
  components: { EmptyData },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      isLogin: false,
      permissionType: 2,
      currentOrg: null,
      orgList: [],
      loading: false,
      activeFilter: 'all',
      rooms: [],
      summary: { total: 0, occupied: 0, free: 0 },
      activeRoomIndex: 0,
      statusFilter: 'all', // all | occupied | free (本地筛选床位状态)
      genderFilter: 'all', // all | '1' | '2' 远程筛选性别 男=1 女=2
      useageFilter: 'all', // all | '1' | '2' 远程筛选用途 全托=1 午托=2
    });

    // 右侧容器，用于内部滚动定位
    const rightContentRef = ref(null);

    // 生成 room 容器 DOM id
    const roomDomId = (room, idx) => `room-section-${room?.roomId || room?.roomNo || idx}`;

    // 左侧点击快速定位到右侧对应房间
    const scrollToRoom = (room, idx) => {
      const id = roomDomId(room, idx);
      const wrap = rightContentRef.value;
      if (!wrap) {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const target = wrap.querySelector(`#${CSS.escape(id)}`);
      if (target) {
        const top = target.offsetTop - 6;
        wrap.scrollTo({ top, behavior: 'smooth' });
      }
    };

    const isOccupied = (bed) => {
      if (!bed) return false;
      if (typeof bed.occupied === 'boolean') return bed.occupied;
      // 兼容后端字段：checkInStatusName 为“空闲”表示空床
      if (typeof bed.checkInStatus === 'number') return bed.checkInStatus !== 0 && bed.checkInStatus !== 3; // 依据业务可再调整
      if (bed.checkInStatusName) return bed.checkInStatusName !== '空闲';
      return !!bed.userName;
    };

    const isPending = (bed) => {
      if (!bed) return false;
      if (typeof bed.checkInStatus === 'number') return bed.checkInStatus === 2;
      if (bed.checkInStatusName) return String(bed.checkInStatusName).includes('待');
      return false;
    };

    const bedStatusClass = (bed) => (isPending(bed) ? 'pending' : isOccupied(bed) ? 'occupied' : 'free');

    const bedStatusTextClass = (bed) => {
      if (!bed) return 'chip-primary';
      if (isPending(bed)) return 'chip-danger';
      if (isOccupied(bed)) return 'chip-warning';
      return 'chip-primary';
    };

    // 上下铺图标：上铺 arrow-up，下铺 arrow-down，未知 exchange
    const bunkIcon = (bed) => {
      const pos = bed?.bedPosition;
      const name = bed?.bedPositionName || '';
      if (pos === 1 || /上/.test(name)) return 'arrow-up';
      if (pos === 0 || /下/.test(name)) return 'arrow-down';
      return 'exchange';
    };

    // 上下铺圆点样式类：上铺 up，下铺 down，未知 unknown
    const bunkDotClass = (bed) => {
      const pos = bed?.bedPosition;
      const name = bed?.bedPositionName || '';
      if (pos === 1 || /上/.test(name)) return 'up';
      if (pos === 0 || /下/.test(name)) return 'down';
      return 'unknown';
    };

    // 远程筛选：房间列表不再做本地性别过滤，直接返回加载后的 rooms
    const displayedRooms = computed(() => state.rooms);

    // 顶部筛选：按床位状态过滤床位
    const filteredBeds = (room) => {
      const beds = room?.beds || [];
      if (state.statusFilter === 'all') return beds;
      const needOccupied = state.statusFilter === 'occupied';
      return beds.filter(b => needOccupied ? isOccupied(b) : !isOccupied(b));
    };

    // 跳转入住记录页面
    const goBedRecords = (room, bed) => {
      const bedId = bed?.bedId || bed?.bedNo;
      const roomNo = room?.roomNo;
      const bedNo = bed?.bedNo;
      const sexName = room?.sexName;
      let bedPositionName = bed?.bedPositionName;
      if (!bedPositionName) {
        const cls = bunkDotClass(bed);
        bedPositionName = cls === 'up' ? '上铺' : cls === 'down' ? '下铺' : '';
      }
      router.push({ path: '/checkinRecords', query: { bedId, roomNo, bedNo, sexName, bedPositionName } });
    };

    const onStatusChange = () => {
      // 本地床位状态筛选
    };
    const onGenderChange = async () => {
      // 性别改为远程筛选
      await fetchData();
      rightContentRef.value?.scrollTo({ top: 0 });
    };
    const onUseageChange = async () => {
      // 用途远程筛选
      await fetchData();
      rightContentRef.value?.scrollTo({ top: 0 });
    };

    const onRefresh = async () => {
      await fetchData();
    };

    const handleOrgChange = async (value) => {
      state.currentOrg = value;
      localStorage.setItem('currentOrg', state.currentOrg);
      localStorage.setItem('bedBoardUserSelected', '1');
      await fetchData();
    };

    

    const fetchData = async () => {
      if (!localStorage.getItem('token') || !localStorage.getItem('userInfo')) {
        state.isLogin = false;
        return;
      }
      try {
        state.loading = true;
        const toast = showLoadingToast({ message: '加载中...', duration: 0, forbidClick: true });
        const params = {
          createOrg: state.currentOrg,
          sex: state.genderFilter === 'all' ? undefined : Number(state.genderFilter),
          useage: state.useageFilter === 'all' ? undefined : Number(state.useageFilter),
        };
        const res = await postRoomBedUsageStats(params);
        closeToast();
        state.loading = false;
        if (res && res.code === '00') {
          const rawRooms = Array.isArray(res.data) ? res.data : [];
          // 规范化 room 与 bed 字段
          const rooms = rawRooms.map((r) => {
            const beds = Array.isArray(r.bedList) ? r.bedList.map(b => ({
              bedId: b.bedId,
              bedNo: b.bedNo,
              bedPositionName: b.bedPositionName,
              checkInStatus: b.checkInStatus,
              checkInStatusName: b.checkInStatusName,
              userName: b.userName,
              occupied: b.checkInStatusName ? b.checkInStatusName !== '空闲' : !!b.userName,
              checkInDate: b.checkInDate,
              expireDate: b.expireDate,
              statusFlag: b.statusFlag,
            })) : [];
            const occupied = beds.filter(b => b.checkInStatus === 2).length;
            const total = beds.length;
            const pending = beds.filter(b => b.checkInStatus === 1).length;
            const free = Math.max(total - occupied - pending, 0);
            
            return {
              roomId: r.roomId,
              roomNo: r.roomNo,
              roomName: r.roomNo || r.name,
              number: r.number,
              sexName: r.sexName,
              useageName: r.useageName,
              beds,
              occupied,
              free,
              total,
              pending
            };
          });
          // 汇总
          const totalBeds = rooms.reduce((sum, r) => sum + (r.total || 0), 0);
          const totalOccupied = rooms.reduce((sum, r) => sum + (r.occupied || 0), 0);
          const totalPending = rooms.reduce((sum, r) => sum + (r.pending || 0), 0);
          state.summary.total = totalBeds;
          state.summary.occupied = totalOccupied;
          state.summary.pending = totalPending;
          state.summary.free = Math.max(totalBeds - totalOccupied, 0);
          state.rooms = rooms;
          state.activeRoomIndex = 0;
          state.isLogin = true;
        } else if (res && res.code === '02') {
          state.isLogin = false;
        } else {
          state.rooms = [];
          showNotify({ type: 'warning', message: res?.message || '获取数据失败' });
        }
      } catch (e) {
        closeToast();
        state.loading = false;
        showNotify({ type: 'danger', message: '网络异常或接口错误' });
      }
    };

    const querySysOrgListByUser = async () => {
      state.orgList = [];
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        state.permissionType = userInfo?.permissionType ?? 2;
        const result = await querySelectOrgListByUser({ id: userInfo?.id });
        if (result.code === '00') {
          state.orgList = (result.data || []).map(item => ({ ...item, text: item.name, value: item.id }))
            .filter(item => item.id !== 1);
          const entryFlag = sessionStorage.getItem('bedBoardEntry');
          const useOuterOnce = entryFlag === 'console' && route?.query?.currentOrg;
          if (useOuterOnce) {
            state.currentOrg = Number(route.query.currentOrg);
            localStorage.setItem('currentOrg', state.currentOrg);
            localStorage.setItem('bedBoardUserSelected', '0');
            sessionStorage.removeItem('bedBoardEntry');
          } else if (localStorage.getItem('currentOrg')) {
            state.currentOrg = Number(localStorage.getItem('currentOrg'));
          } else {
            state.currentOrg = state.orgList[0]?.value || null;
          }
          await fetchData();
        }
      } catch (e) {
        state.orgList = [];
      }
    };

    onMounted(async () => {
      const _user = localStorage.getItem('userInfo');
      state.isLogin = !!(localStorage.getItem('token') && _user);
      if (!state.isLogin) return;
      await querySysOrgListByUser();
    });

    return {
      state,
      bedStatusClass,
      bunkIcon,
      bunkDotClass,
      bedStatusTextClass,
      isOccupied,
      handleOrgChange,
      onRefresh,
      rightContentRef,
      roomDomId,
      scrollToRoom,
      displayedRooms,
      filteredBeds,
      goBedRecords,
      onStatusChange,
      onGenderChange,
      onUseageChange,
    };
  }
});
</script>

<style lang="scss" scoped>
:deep(.van-dropdown-menu__bar) {
  background: none !important;
  box-shadow: none !important;
}

.bed-board-page {
  background: #e9f1f8;
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  padding-bottom: 20px;

}

.org-content {
  margin: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.summary {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 8px 10px;
  background: #fff;
  border-radius: 8px;
  padding: 10px 0;
}
.summary-item { font-weight: 600; color: #113050; }

.board-container {
  display: flex;
  gap: 10px;
  margin: 0 10px;
}

/* 状态色块说明样式 */
.legend {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 10px 6px 10px;
  padding: 8px 10px;
  background: #fff;
  border-radius: 8px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid transparent;
}
.legend-text { color: #606266; font-size: 12px; }
.legend-occupied {  background: #fff5f5; border-color: #ffb0b0; }
 
.legend-pending { background: #fdf6ec; border-color: #e6a23c; }
.legend-free { background: #ffffff; border-color: #e4e7ed; }

/* 顶部快速筛选 */
.quick-filters {
  margin: 0 10px 8px 10px;
  display: flex;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 5;
}
.filter-group {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-label { color: #86909c; font-size: 12px; white-space: nowrap; font-weight: 600; }

/* Vant Tabs -> 分段选择器风格 */
.filter-group :deep(.van-tabs__wrap) { height: 28px; }
.filter-group :deep(.van-tabs__nav) {
  background: #f5f7fa;
  border-radius: 999px;
  padding: 2px;
}
.filter-group :deep(.van-tabs__line) { display: none; }
.filter-group :deep(.van-tab) {
  height: 24px;
  line-height: 24px;
  border-radius: 999px;
  padding: 0 10px;
  margin: 0 2px;
}
.filter-group :deep(.van-tab--active) {
  background: #1677ff;
  color: #fff;
}

.left-list {
  width: 28%;
}

.right-content {
  width: 100%;
  // width: 72%;
  max-height: calc(100vh - 156px);
  overflow-y: auto;
}

.filter-bar {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
}

.room-list {
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  max-height: calc(100vh - 112px);
  overflow-y: auto;
}

.room-item {
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}
.room-item.active { border-color: #667eea; box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15); }

.room-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #333;
}

.room-stats {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  color: #86909c;
}
.stat { display: flex; align-items: center; gap: 4px; }

.room-panel {
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 6px;
}

.stu-name {
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.room-name { font-weight: 700; color: #113050; }
.panel-meta { color: #86909c; font-size: 12px; }

.bed-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.bed-card {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.bed-card.occupied { border-color: #e6a23c; background: #fdf6ec; }
.bed-card.free { border-color: #e4e7ed; background: #ffffff; }
.bed-card.pending { border-color: #ffb0b0; background: #fff5f5; }

.bed-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.bed-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }
.bed-sub { margin-top: 8px; color: #303133; font-size: 12px; }
.bed-no { font-size: 12px;font-weight: 600; color: #333;white-space: nowrap;height: 14px;line-height: 14px; }
.tags { display: flex; gap: 6px; align-items: center; }

.stu-empty {
  text-align: center;
  color: #c0c4cc;
  font-size: 12px;
  padding-top: 6px;
}

/* 上下铺图标样式 */
.bunk-badge {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
  border: 1px solid #e4e7ed;
  margin-top: -4px;
}

/* 上下铺圆点 */
.bunk-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.bunk-dot.up { background: #1677ff; }
.bunk-dot.down { background: #909399; }
.bunk-dot.unknown { background: #dcdfe6; }
.bunk-dot.dai { background: #faad14; }
/* 状态胶囊 */
.chip { font-size: 12px; font-weight: 600;white-space: nowrap; height: 14px;line-height: 14px; }
.chip-primary { background: #ffffff; color: #1677ff;}
.chip-danger { background: #fff2f0; color: #ff4d4f; }
.chip-warning { background: #fffbe6; color: #faad14;}

.bed-meta {
  font-size: 12px;
  text-align: left;
}


/* 响应式：小屏下左右改为上下 */
@media (max-width: 375px) {
  .board-container { flex-direction: column; }
  .left-list, .right-content { width: 100%; }
}
</style>
